import { Rndm } from './Rndm.js';
import { Arry } from './Arry.js';

import { V2, XY } from './V2.js';

export interface lnks_type {
    id: string;
    type: "lnks";
    a: any,
    b: any,
    stiffness: number;
    distance: number;
    distance_initial: number;
    offset: XY;
    pos: XY;
    start_a: XY;
    start_b: XY;
    kill: () => void;
    calc: () => void;
    [key: string]: any;
}

export interface lnks_manager_type {
    list: lnks_type[];
    get: (id: string) => any | null;
    kill: (id: string) => void;
    make: (io: any) => lnks_type;
    run: () => void;
}

export function lnks_manager(iterations = 10) {

    return {
        list: [] as lnks_type[],
        get: function (id: string): any | null {
            return Arry.get.id(this.list, id)
        },
        kill: function (id: string): void {
            const link = Arry.get.id(this.list, id);
            if (link) link.kill();
        },
        make: function (io: any): lnks_type {
            const l = {
                ...io,
                type: "lnks",
                id: io.id || Rndm.id(),
                stiffness: io.stiffness || 0.01,
                distance: io.distance !== undefined ? io.distance : "auto",
                distance_initial: 0,
                start_a: { x: 0, y: 0 },
                start_b: { x: 0, y: 0 },
                offset: { x: io.off_x || 0, y: io.off_y || 0 },
                kill: () => Arry.remove.id(this.list, l.id),
                calc: function () {

                    const aTrue = V2.new.add(l.a.pos, l.a.dif);
                    const bTrue = V2.new.add(l.b.pos, l.b.dif);
                    V2.add(aTrue, l.offset);

                    const diff = V2.new.sub(aTrue, bTrue);
                    const d = V2.get.length(diff) || 0.001;
                    const difScalar = (l.distance - d) / d * l.stiffness;

                    V2.scale(diff, difScalar * 0.5);
                    V2.add(l.a.dif, V2.new.scale(diff, l.b.mass || 1));
                    V2.sub(l.b.dif, V2.new.scale(diff, l.a.mass || 1));
                }
            };

            if (l.distance == "auto") l.distance = V2.get.distance(l.a.pos, l.b.pos);
            l.distance_initial = l.distance;
            V2.set(l.start_a, l.a.pos);
            V2.set(l.start_b, l.b.pos);

            this.list.push(l);
            return l;
        },
        run: function (): void {
            for (let i = 0; i < iterations; i++) {
                for (const l of this.list) l.calc();
            }
        }
    };
}